import { Link } from 'react-router-dom';
import { useAccelerationTierEnabled } from '../api/capabilities.js';

export function AdminPage(): JSX.Element {
  const tierEnabled = useAccelerationTierEnabled();
  const allTiles = [
    {
      to: '/admin/data-sources',
      title: 'Data Sources',
      desc: 'Register sources, sync catalogs, accelerate datasets into ClickHouse.',
      ready: true,
    },
    {
      to: '/admin/schedules',
      title: 'Scheduling & Delivery',
      desc: 'Cron schedules, email / webhook delivery, retries — attach to each Report.',
      ready: true,
    },
    {
      to: '/admin',
      title: 'Users & Roles',
      desc: 'Per-tenant RBAC, folder ACLs, approval workflows.',
      ready: false,
      phase: 'Phase 2',
    },
    {
      to: '/admin/audit',
      title: 'Audit',
      desc: 'Append-only audit log, filter by action / artifact / outcome, auto-refreshing live feed.',
      ready: true,
    },
    {
      to: '/admin/cubes',
      title: 'Cubes',
      desc: 'Sage cube engine — list registered cubes (platform + customer), trigger refreshes, view build history. ADR-004.',
      ready: true,
    },
    {
      to: '/admin',
      title: 'LLM Providers',
      desc: 'Anthropic direct / Bedrock / Vertex; per-tenant provider selection; token quotas.',
      ready: false,
      phase: 'Phase 2',
    },
  ];
  // CSAGE-437: cube authoring is offered only where the acceleration tier is.
  const tiles = allTiles.filter((t) => t.to !== '/admin/cubes' || tierEnabled === true);
  return (
    <>
      <header className="page-title">
        <div>
          <h1>Admin</h1>
          <p className="page-title-subtitle">
            Operational surfaces. Data source registration, catalog sync, cube acceleration,
            scheduling, delivery, audit, user management.
          </p>
        </div>
      </header>

      <div className="grid-2">
        {tiles.map((t) =>
          t.ready ? (
            <Link
              key={t.title}
              to={t.to}
              className="card"
              style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}
            >
              <div className="card-body">
                <div className="row row--between" style={{ marginBottom: 8 }}>
                  <h3>{t.title}</h3>
                  <span className="badge badge--success">Ready</span>
                </div>
                <p className="text-dim text-sm" style={{ margin: 0 }}>
                  {t.desc}
                </p>
              </div>
            </Link>
          ) : (
            <div key={t.title} className="card" style={{ opacity: 0.7 }}>
              <div className="card-body">
                <div className="row row--between" style={{ marginBottom: 8 }}>
                  <h3>{t.title}</h3>
                  <span className="badge badge--neutral">{t.phase}</span>
                </div>
                <p className="text-dim text-sm" style={{ margin: 0 }}>
                  {t.desc}
                </p>
              </div>
            </div>
          ),
        )}
      </div>
    </>
  );
}
